import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";

async function fetchRelatedTasksForProduct(shortId: string) {
  const result = await httpClient.tasks.get<{ data: unknown }>(
    "/v1/tasks/for_product",
    { params: { short_id: shortId } }
  );
  return result.data;
}

export function useRelatedTasksForProduct(shortId: string) {
  return useQuery({
    enabled: !!shortId,
    queryKey: ["tasks", "product", shortId],
    queryFn: async () => await fetchRelatedTasksForProduct(shortId),
    staleTime: 0,
  });
}
